import { apiService as Service } from '@/services/service'

const url = 'dashboard'

export const dashboardService = {
	index: () => Service.get({ url }),
}

export default dashboardService
